export default "__VITE_ASSET__Cigi7PNC__"